/* @flow */

import React, { Component } from 'react';
import $ from 'jquery';
import { displayError } from 'utils/errors';
import fetch, { post } from 'utils/fetch';
import { Modal, Button } from 'semantic-ui-react';
import cx from 'classnames';

type Props = {
  open: boolean,
  id: string,
  url: string,
  onClose: () => void,
  onAccepted: (response: Response) => void,
};

type State = {
  isAccepting: boolean,
  form?: any,
  error?: string,
};

class AcceptAccountRequestModal extends Component {
  props: Props;
  state: State;

  form: HTMLFormElement;

  constructor(props: Props) {
    super(props);

    this.state = {
      isAccepting: false,
    };
  }

  componentDidMount() {
    const { id } = this.props;

    fetch(`/accounts/requests/${id}/new`).then(res => res.text()).then(text =>
      this.setState({
        form: {
          __html: text,
        },
      })
    );
  }

  setForm = (ref: HTMLFormElement) => {
    this.form = ref;

    // Enabling tags dropdown
    $(ref).find('.dropdown.tags').dropdown({
      allowAdditions: true,
    });
  };

  onAccept = () => {
    const { id, onAccepted } = this.props;

    if (this.form) {
      const data = new FormData(this.form);

      this.setState({
        isAccepting: true,
      });

      post(`/accounts/requests/${id}/accept`, data)
        .then(onAccepted)
        .catch(error => {
          if (error.res.text) {
            return error.res.text().then(text =>
              this.setState({
                isAccepting: false,
                error: '',
                form: {
                  __html: text,
                },
              })
            );
          } else {
            this.setState({
              isAccepting: false,
              error: displayError(error),
            });
          }
        });
    }
  };

  render() {
    const { open, onClose } = this.props;
    const { form, isAccepting, error } = this.state;

    const formClass = cx('ui form', {
      error: error !== undefined,
    });

    return (
      <Modal closeIcon size="small" open={open} onClose={onClose}>
        <Modal.Header>Création de compte</Modal.Header>
        <Modal.Content>
          {form &&
            <form className={formClass} ref={this.setForm}>
              {error &&
                error.length &&
                <div className="ui error message">
                  <p>{error}</p>
                </div>}
              <div dangerouslySetInnerHTML={form} />
            </form>}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Annuler</Button>
          <Button
            loading={isAccepting}
            onClick={this.onAccept}
            primary
            icon="save"
            labelPosition="right"
            content="Créer le compte"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default AcceptAccountRequestModal;



// WEBPACK FOOTER //
// ./src/modules/user/components/AcceptAccountRequestModal.js